import React from "react";
import { useTranslation } from "react-i18next";
import { Edit } from "lucide-react"; // icon for rating stars
import { CarBrand } from "../../../types/modules/admin/carBrand.type";
import CarBrandItem from "./CarBrandItem";
import { PermissionGate } from "../PermissionGate";
import { PermissionsKey } from "../../../data/permissions";

interface Props {
  carBrands: CarBrand[];
}

const CarBrandsTable: React.FC<Props> = ({ carBrands }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal capitalize">{t("id")}</th>
            <th className="p-3 font-normal capitalize">{t("name_in_english")}</th>
            <th className="p-3 font-normal capitalize">{t("name_in_arabic")}</th>
            <PermissionGate permissions={[PermissionsKey.UpdateCarBrand]}>
              <th className="p-3 font-normal capitalize">{t("actions")}</th>
            </PermissionGate>
          </tr>
        </thead>
        <tbody className="text-sm">
          {carBrands.map((car, index) => (
            <tr
              key={car.id}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
             <CarBrandItem carBrand={car}/>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default CarBrandsTable;